import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { environment } from 'src/environments/environment';

import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { GlobalVariable } from 'src/app/shared/global-variable';
import { Tab } from 'src/app/shared/model/tab.model';
import { TabService } from 'src/app/shared/services/tab.service';
import { InvoiceComponent } from 'src/app/transactions/invoice/invoice.component';
import { InitialState } from 'src/app/store/reducer';
import { Store } from '@ngrx/store';
import { OpenAdvanceSearchModal } from 'src/app/transactions/store/actions';
import { DownloadService } from 'src/app/shared/download.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-sales-purchase-report',
  templateUrl: './sales-purchase-report.component.html',
  styleUrls: ['./sales-purchase-report.component.scss']
})
export class SalesPurchaseReportComponent implements OnInit {
  fromRoot = true;
  isPrint: any;
  selector: string = '.main-panel';
  fromIndex: any = 0;
  dataLimit: any = 100;
  toIndex: any = 30;
  allInvoiceArr: any;
  showPrintData: boolean = false;
  invoiceFilterForm: FormGroup;
  innerHeight: string;
  invoiceArr = [];
  clientArr: any;
  keyword = 'name';
  navigationSubscription
  reInitialise = false;
  totalAmountObj = {}
  p;
  valid: boolean;
  onSearch;
  listOfColumns = []
  onSearchFilter = new Subject<string>();
  keys: any
  isSuccess: boolean = false;
  showMessage: boolean = false;
  alertType = ''
  message: string = ``;
  invoice_number = ``;

  isAdvancedSearchOpen: boolean = false;
  currentIndex = 0
  @ViewChild('tableHeader', { static: true }) tableHeader: ElementRef
  advancedSearchSubscription: Subscription;
  queryData: any;
  companyDetail: any;
  currentDate = new Date()
  loader: boolean = false;
  inv_duration: any;
  travel_duration: any;
  duration: any;
  queryParams: any;
  constructor(
    public commonService: CommonServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private tabService: TabService,
    private downloadService: DownloadService,
    private store: Store<InitialState>,
    private spinner: NgxSpinnerService,

  ) {

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initialiseInvites();
      }
    });
  }

  ngOnInit() {

    let queryParams = JSON.parse(JSON.stringify(this.route.queryParams['value']))
    this.queryData = Object.assign({}, queryParams)
    localStorage.setItem('activeSalesPurchaseSearchQuery', JSON.stringify(queryParams))
    this.fromIndex = 0;
    queryParams['apply_limit'] = true
    queryParams['limit'] = 30;
    queryParams['offset'] = this.fromIndex;
    this.onSearch = ''
    this.search(queryParams)
    this.queryParams = queryParams
    this.reInitialise = true
    this.onSearchFilter.pipe(
      debounceTime(300),
      distinctUntilChanged())
      .subscribe(value => {
        this.filterData(value)
      });


  }

  initialiseInvites() {
    if (this.reInitialise) {
      this.ngOnInit()
    }
  }

  ngAfterViewInit() {
    this.advancedSearchSubscription = this.commonService.advancedSearch.subscribe(status => {
      console.log('Is modal opened : ', status)
    })
  }
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    if (this.advancedSearchSubscription) {
      this.advancedSearchSubscription.unsubscribe()
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setHeight(event.target.innerHeight)
  }


  setHeight(height) {
    if (this.invoiceArr != undefined) {
      if (height == undefined) {
        height = window.innerHeight
      }
      if (this.invoiceArr.length <= 9) {
        this.innerHeight = 'auto';
      }
      else {
        this.innerHeight = height - 180 + 'px';
      }
    }
  }

  async search(values) {
    let reqObj = Object.assign({}, values)

    this.loader = true;
    let resp = await this.getData(reqObj)

    this.loader = false;
    if (resp) {
      this.duration = resp['duration']
      this.invoiceArr = resp['data']
      this.allInvoiceArr = resp['data']
      this.totalProfitCalculate()
      this.focusOnTableHeader()
      this.currentIndex = 0
      this.setHeight(window.innerHeight)

      let firstRow = document.getElementById('rowIndex_1') as HTMLElement
      if (firstRow) {
        firstRow.scrollIntoView()
      }
    }

  }



  getData(values) {
    return new Promise(async (resolve, reject) => {
      this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/reports/sales-purchase-report`, values).subscribe(res => {
        resolve(res)
      }, err => {
        console.log('err', err);
        window.scroll(0, 0)
        this.showMessage = true;
        this.isSuccess = false
        this.invoice_number = ''
        this.alertType = 'error-box';
        this.message = err['error']['message']
        resolve(null)
      })
    })
  }

  async onScrollDown(event) {
    this.fromIndex += 30
    let queryParams = JSON.parse(JSON.stringify(this.queryParams))
    queryParams['limit'] = 30;
    queryParams['offset'] = this.fromIndex;
    let resp = await this.getData(queryParams)
    if (resp) {
      this.invoiceArr = this.invoiceArr.concat(resp['data'])
      this.totalProfitCalculate()
      this.setHeight(window.innerHeight)
    }
  }

  openAdvanceSearchModal() {
    this.store.dispatch(new OpenAdvanceSearchModal({ status: true, title: 'sales-purchase-report' }));
  }

  getLimitData(offset) {
    let url = `${environment.okountUrl}/globalsearch/e-invoice-list`
    let value = Object.assign({}, this.queryData)
    this.loader = true;
    value['limit'] = this.dataLimit
    value['offset'] = offset
    value['apply_limit'] = true
    this.commonService.getRequestWithQueryParamsNoLoader(`${url}`, value).subscribe(res => {
      for (const key in res['data']) {
        if (Object.prototype.hasOwnProperty.call(res['data'], key)) {
          const element = res['data'][key];
          if (element != undefined) {
            // this.toIndex = i
            if (this.invoiceArr == undefined) {
              this.invoiceArr = []
            }
            this.invoiceArr.push(element)
          }
        }
      }
      this.loader = false;
      this.focusOnTableHeader()
      this.currentIndex = 0
      this.setHeight(window.innerHeight)
      this.valid = true

    })
  }

  onScrollUp(event) {
  }

  openInvoice(invoice_number) {
    let path = `${environment.name == 'v3-stage' || environment.name == 'v3-prod' ? '/v3/' : "/"}#/transactions/invoice/view/${invoice_number}`

    if (window.location.protocol != 'file:') {
      if (invoice_number) {
        let title = ''
        let newInvoiceParts = invoice_number.split('-')
        title += newInvoiceParts[0]
        title += '...'
        title += newInvoiceParts[newInvoiceParts.length - 1]
        this.tabService.addTab(
          new Tab(InvoiceComponent, `${title}`, { invoice: invoice_number, mode: 'view' }, invoice_number)
        );
      } else {
        window.open(path, '_blank')
      }
    } else {
      var customeEventHandler = new CustomEvent("handle-window-open", {
        "detail": {
          hashPath: path
        }
      });
      window.dispatchEvent(customeEventHandler)
    }
  }

  focusOnTableHeader() {
    if (this.tableHeader != undefined) {
      this.tableHeader.nativeElement.focus()
    }
  }

  onKeyDown(e: any) {
    console.log('openModalStatus : ' + GlobalVariable.openModalStatus)
    if (GlobalVariable.openModalStatus == false && GlobalVariable.openGlobalSearch == false) {
      if (e.keyCode == 40) {
        e.preventDefault();
        this.moveToNext()
      } else if (e.keyCode === 38) {
        e.preventDefault();
        this.moveToPrev()
      }
    }
  }
  moveToNext() {
    if (document.getElementById(`rowIndex_${this.currentIndex + 1}`) != null) {
      document.getElementById(`rowIndex_${this.currentIndex + 1}`).focus()
      this.currentIndex = this.currentIndex + 1
    }
  }
  moveToPrev() {
    if (document.getElementById(`rowIndex_${this.currentIndex - 1}`) != null) {
      document.getElementById(`rowIndex_${this.currentIndex - 1}`).focus()
      this.currentIndex = this.currentIndex - 1
    }
  }

  moveToIndex(i) {
    document.getElementById(`rowIndex_${i + 1}`).focus()
    this.currentIndex = i + 1
  }


  oldFilterData(value) {
    let tempArr = Object.assign([], this.allInvoiceArr)
    if (value.length >= 3) {
      let lowerCaseFilter = value.toLowerCase()
      let upperCaseFilter = value.toUpperCase()
      this.invoiceArr = tempArr.filter(
        invoiceData => {
          if ((
            invoiceData.affiliate_name != undefined &&
            invoiceData.affiliate_name != null &&
            (invoiceData.affiliate_name.includes(value) ||
              invoiceData.affiliate_name.includes(upperCaseFilter) ||
              invoiceData.affiliate_name.includes(lowerCaseFilter)
            )
          ) ||
            (
              invoiceData.invoice_no != undefined &&
              invoiceData.invoice_no != null &&
              (
                invoiceData.invoice_no.includes(value) ||
                invoiceData.invoice_no.includes(upperCaseFilter) ||
                invoiceData.invoice_no.includes(lowerCaseFilter)
              )
            ) ||
            (
              invoiceData.total != undefined &&
              invoiceData.total != null &&
              (
                invoiceData.total.toString().includes(value) ||
                invoiceData.total.toString().includes(upperCaseFilter) ||
                invoiceData.total.toString().includes(lowerCaseFilter)
              )
            ) //Convert Number to string.

          ) {
            return invoiceData
          }
          console.log(invoiceData)
        }
      )
      this.setHeight(window.innerHeight)
    } else {
      this.invoiceArr = []
      for (let i = 0; i <= 30; i++) {
        const element = this.allInvoiceArr[i];
        if (element != undefined) {
          this.toIndex = i
          this.invoiceArr.push(element)
        }
      }
      this.setHeight(window.innerHeight)
    }
  }

  async filterData(value) {
    if (value.length >= 0) {
      this.queryParams['freetext'] = value
      let queryParams = JSON.parse(JSON.stringify(this.queryParams))
      this.queryParams = queryParams
      this.fromIndex = 0
      queryParams['limit'] = 30;
      queryParams['offset'] = this.fromIndex;
      this.loader = true
      let resp = await this.getData(queryParams)
      this.loader = false
      if (resp) {
        this.invoiceArr = resp['data']
        this.totalProfitCalculate()

        this.duration = resp['duration']
        let firstRow = document.getElementById('rowIndex_1') as HTMLElement
        if (firstRow) {
          firstRow.scrollIntoView()
        }

      }

      this.setHeight(window.innerHeight)
    } else {
      delete this.queryParams['freetext']
      this.search(this.queryParams)
      this.setHeight(window.innerHeight)
    }
  }


  async exportAsXLSX() {
    try {
      this.spinner.show();

      const data: any = this.invoiceArr;
      // const salesData = data.salesData || [];
      // const purchaseData = data.purchaseData || [];
      // const revFromOperationData = data.revFromOperationData || [];

      // const servicesToInclude = ['FLIGHT','HOTEL', 'INSURANCE', 'MISC', 'TOUR', 'VISA', 'BUS', 'RAIL', 'CAR'];
      // const grouped: Record<string, any> = {};

      // // Step 1: Initialize services
      // for (const service of servicesToInclude) {
      //     grouped[service] = {
      //       NAME: service,
      //       Sales: 0,
      //       Purchase: 0,
      //       'REVENUE FROM OPERATION':0,
      //       Profit: 0,
      //     };
      let xlsxData = [];

      for (const obj of data) {
       let Row = {
          'Service name': obj.service_type,
          Sales: Number(obj.sales_amount) && !isNaN(Number(obj.sales_amount)) ? Number(obj.sales_amount).toFixed(2) : '0.00',  // Handle invalid numbers
          Purchase: Number(obj.purchase_amount) && !isNaN(Number(obj.purchase_amount)) ? Number(obj.purchase_amount).toFixed(2) : '0.00',
          Profit: Number(obj.profit) && !isNaN(Number(obj.profit)) ? Number(obj.profit).toFixed(2) : '0.00',
        };

        xlsxData.push(Row);
      }

      //     for (const purchase of purchaseData) {
      //       const name = purchase.name;
      //      if (name.toUpperCase().includes(service)) {
      //         grouped[service].Purchase += Number(purchase.total || 0);
      //       }
      //     }
          
      //     for (const operation of revFromOperationData) {
      //       const name = operation.name;
      //       if (name.toUpperCase().includes(service)) {
      //         grouped[service]['REVENUE FROM OPERATION'] += Number(operation.total || 0);
      //         operation.is_included = true;
      //       }
      //     }
      // }
      // grouped['FLIGHT']['REVENUE FROM OPERATION'] += revFromOperationData.reduce((sum, item) => {
      //   if (!item.is_included) {
      //     sum+= Number(item.total || 0);
      //   }
      //   return sum;
      // },0)

      // // Step 4: Compute profit
      // for (const service of servicesToInclude) {
      //   grouped[service].Profit = grouped[service].Sales + grouped[service].Purchase+grouped[service]['REVENUE FROM OPERATION'] ;
      // }

      // // Step 5: Prepare final export data
      // const xlsxData = Object.values(grouped);

      // Step 6: Add total row
      const totalRow = {
        'Service name': 'TOTAL',
        Sales: Number(this.totalAmountObj['sales'].toFixed(2)),
        Purchase: Number(this.totalAmountObj['purchase'].toFixed(2)),
        Profit: Number(this.totalAmountObj['profit'].toFixed(2)),
      };

      xlsxData.push({});
      xlsxData.push(totalRow);

      // Step 7: Export
      this.downloadService.exportAsXLSX('Grouped Report by Service', xlsxData);

    } catch (err) {
      console.error('Export failed', err);
    } finally {
      this.spinner.hide();
    }
  }


  getAllData() {
    this.loader = true;
    let queryParams = JSON.parse(localStorage.getItem("activeSalesPurchaseSearchQuery"))
    return new Promise(async (resolve, reject) => {
      this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/e-invoice-list`, queryParams).subscribe(res => {
        this.loader = false;
        resolve(res)

      }, err => {
        resolve(null)
        this.loader = false;
      })
    })
  }

  hideError() {
    this.showMessage = false
  }

  totalProfitCalculate() {
    let purchaseTotal = 0;
    let salesTotal = 0;
    let profitTotal = 0;
    for (let item of this.invoiceArr) {
      salesTotal += Number(item.sales_amount);
      purchaseTotal += Number(item.purchase_amount);
      profitTotal += Number(item.profit);

    }
    
    this.totalAmountObj['sales'] = salesTotal;
    this.totalAmountObj['purchase'] = purchaseTotal;

    this.totalAmountObj['profit'] = profitTotal
  }

}
